import { MiddlewareAction } from "../middleware";
import { EmployerSettings, EmployerSettingsPatchDto } from "../reducers/employer.reducer";
import { UpdateEmployerConfigRequest } from "../models/creditDecision";

export enum EmployerActions {
  REQUEST_GET_EMPLOYER = "REQUEST_GET_EMPLOYER",
  REQUEST_GET_EMPLOYERS = "REQUEST_GET_EMPLOYERS",
  REQUEST_GET_EMPLOYER_SETTINGS = "REQUEST_GET_EMPLOYER_SETTINGS",
  REQUEST_UPDATE_EMPLOYER_SETTINGS = "REQUEST_UPDATE_EMPLOYER_SETTINGS",
  REQUEST_UPDATE_EMPLOYER_CONFIG = "REQUEST_UPDATE_EMPLOYER_CONFIG",
}

export function getEmployer(employerId: string): MiddlewareAction {
  return {
    actionName: EmployerActions.REQUEST_GET_EMPLOYER,
    type: "GET",
    url: `/employers/${employerId}`,
  };
}

export function getEmployers(): MiddlewareAction {
  return {
    actionName: EmployerActions.REQUEST_GET_EMPLOYERS,
    type: "GET",
    url: "/employers",
    throwOnError: true,
  };
}

export function getEmployerSettings(employerId: string): MiddlewareAction {
  return {
    actionName: EmployerActions.REQUEST_GET_EMPLOYER_SETTINGS,
    type: "GET",
    url: `/employers/${employerId}/underwriting-config`,
  };
}

export function updateEmployerSettings(
  employerId: string,
  settings: EmployerSettingsPatchDto
): MiddlewareAction {
  return {
    actionName: EmployerActions.REQUEST_UPDATE_EMPLOYER_SETTINGS,
    type: "PATCH",
    url: `/employers/${employerId}/underwriting-config`,
    body: settings,
  };
}

export function updateEmployerConfig(
  employerId: string,
  config: UpdateEmployerConfigRequest
): MiddlewareAction {
  return {
    actionName: EmployerActions.REQUEST_UPDATE_EMPLOYER_CONFIG,
    type: "PATCH",
    url: `/employers/${employerId}/update-config`,
    body: config,
  };
}
